// extracted by mini-css-extract-plugin
module.exports = {"tabButton":"tabButton__1p2e3"};